<template>
  <div class="app-root">
    <LeftNavBar v-if="showAppShell">
      <router-view></router-view>
    </LeftNavBar>

    <router-view v-else></router-view>
  </div>
</template>

<script>
import LeftNavBar from './components/LeftNavBar.vue';

export default {
  name: 'App',
  components: {
    LeftNavBar,
  },
  computed: {
    showAppShell() {
      return !['login', 'error'].includes(this.$route.name);
    },
  },
};
</script>

<style scoped>
.app-root {
  min-height: 100vh;
  background: var(--background-color, #ffffff);
}
</style>
